'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.default = Media;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./media.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * WH Media object Component. The media component positions any image- and
 * text-like content side-by-side,
 * @param {Object} props The new component properties.
 * @returns {ReactElement} HTML markup for the component
 */
function Media(props) {
    var _cx;

    var _props$imgSrc = props.imgSrc,
        imgSrc = _props$imgSrc === undefined ? '' : _props$imgSrc,
        _props$imgAltText = props.imgAltText,
        imgAltText = _props$imgAltText === undefined ? '' : _props$imgAltText,
        _props$imgClassName = props.imgClassName,
        imgClassName = _props$imgClassName === undefined ? '' : _props$imgClassName,
        _props$className = props.className,
        className = _props$className === undefined ? '' : _props$className,
        _props$imgHeight = props.imgHeight,
        imgHeight = _props$imgHeight === undefined ? '' : _props$imgHeight,
        _props$imgWidth = props.imgWidth,
        imgWidth = _props$imgWidth === undefined ? '' : _props$imgWidth,
        _props$spacing = props.spacing,
        spacing = _props$spacing === undefined ? '' : _props$spacing,
        _props$isReversed = props.isReversed,
        isReversed = _props$isReversed === undefined ? false : _props$isReversed,
        children = props.children,
        _props$id = props.id,
        id = _props$id === undefined ? '' : _props$id;


    var classNames = (0, _classnames2.default)((_cx = {
        'sb-media': true,
        'sb-media--reverse': !!isReversed
    }, (0, _defineProperty3.default)(_cx, 'sb-media--' + spacing, spacing), (0, _defineProperty3.default)(_cx, '' + className, className), _cx));

    var imgClassNames = (0, _classnames2.default)((0, _defineProperty3.default)({
        'sb-media__img': true
    }, '' + imgClassName, imgClassName));

    var media = imgSrc ? (0, _jsx3.default)('img', {
        className: imgClassNames,
        src: imgSrc,
        alt: imgAltText,
        width: imgWidth,
        height: imgHeight
    }) : (0, _jsx3.default)('div', {
        className: imgClassNames
    });

    return (0, _jsx3.default)('section', {
        className: classNames,
        id: id
    }, void 0, media, (0, _jsx3.default)('article', {
        className: 'sb-media__body'
    }, void 0, children));
}
// css
//# sourceMappingURL=Media.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/media/Media.js
// module id = 578
// module chunks = 0